/* eslint-disable prettier/prettier */
/* This file is automatically generated by the plugin 'request-plugin'. Please do not modify. */

import axios from 'axios';

export const instances = {
  DEFAULT: axios.create({ baseURL: 'https://halo-api.noim.uk' }),
  WS: axios.create({ baseURL: 'wss://halo-api.noim.uk' }),
}

export default Object.assign(instances.DEFAULT, instances);